import React from "react";

import { useTranslation } from "react-i18next";
import { Trans } from "react-i18next";

const StepsNavButtons = ({ back, next, subNext }) => {
    const { t } = useTranslation();

    const renderButtonContent = (field, defaultLabel) => {
        return field.label
            ? loadingButton(field?.label, field?.isSubmitting)
            : t(defaultLabel);
    };

    const loadingButton = (label, isSubmitting) => {
        return isSubmitting ? (
            <>
                <span className="animate-spin mr-3 inline-flex">
                    <i className="fas fa-sync"></i>
                </span>
                <Trans i18nKey="requesting">Requesting...</Trans>
            </>
        ) : (
            label
        );
    };

    const ButtonWrapper = ({ field, isRight, children }) => {
        return (
            <button
                onClick={field.action}
                disabled={field.disabled}
                className={`secondary-green-btn mng-model modal-btn-open ${
                    isRight ? "" : "mr-auto"
                } ${field.disabled ? "disabled" : ""}`}
                id={`create-model-${isRight ? "next" : "back"}-btn`}
            >
                {!isRight && <i className="fas fa-caret-left"></i>}
                <span className={`${isRight ? "mr-2" : "ml-2"}`}>
                    {children}
                </span>
                {isRight && <i className="fas fa-caret-right"></i>}
            </button>
        );
    };

    const SubButtonWrapper = ({ field, isRight, children }) => {
        return (
            <button
                onClick={field.action}
                disabled={field.disabled}
                className={`secondary-green-outline-btn mng-model modal-btn-open ${
                    isRight ? "mr-2" : "mr-auto"
                } ${field.disabled ? "disabled" : ""}`}
                id="create-model-sub-btn"
            >
                <span className={`${isRight ? "" : ""}`}>{children}</span>
            </button>
        );
    };

    return (
        <>
            <div className="steps-manage flex justify-end">
                {back && (
                    <ButtonWrapper field={back} isRight={false}>
                        {renderButtonContent(back, "back")}
                    </ButtonWrapper>
                )}
                {subNext && (
                    <SubButtonWrapper field={subNext} isRight={true}>
                        {renderButtonContent(subNext, "saveAddMore")}
                    </SubButtonWrapper>
                )}
                {next && (
                    <ButtonWrapper field={next} isRight={true}>
                        {renderButtonContent(next, "next")}
                    </ButtonWrapper>
                )}
            </div>
        </>
    );
};

export default StepsNavButtons;
